module.exports = __webpack_public_path__ + "static/img/b.2f88cf0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-go/mobile/photo_pack/b.png
// module id = EGAT
// module chunks = 12